module.exports = __webpack_public_path__ + "static/media/山海邮差.2c9ac7c2.mp3";